export const GLOBAL_KEY = 'GLOBAL'